/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitsConfigVersion } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const useEditBenefitsConfigVersion = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (bVersion: IBenefitsConfigVersion) => BenefitsService.patchBenefitsConfigVersion(bVersion),
    {
      onSuccess: () => {
        AlertAdapter('Version edited', 'success');
        queryClient.invalidateQueries(['benefits-config-version']);
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
  return mutation;
};
